module.exports = __webpack_public_path__ + "static/media/Collections-intimate-celebration-Mobile.5985df62.jpg";